import React, {
  useEffect,
  useRef,
  useState,
  useCallback,
  useImperativeHandle,
} from 'react';
import 'swiper/css';
import {Swiper, SwiperSlide, SwiperRef} from 'swiper/react';
import {getVipConfigListV2, VipConfigVO} from './vip.service';
import VipCard, {VipMaxLevelContext} from './vip-card';
import {Swiper as SwiperType} from 'swiper/types';
import {vipOptionsV2} from './vip.variable';

export interface VipCardListV2Props {
  login: boolean;
  // 会透出更多信息，其他地方会用到
  onCardChange?: (vip: VipConfigVO) => void;
  onVipLevel?: (level: number) => void;
}

export interface VipCardListV2Ref {
  refresh: () => void;
}

const VipCardListV2 = React.forwardRef<VipCardListV2Ref, VipCardListV2Props>(
  ({login, onCardChange, onVipLevel}, ref) => {
    const [vipVOList, setVipVOList] = useState<VipConfigVO[]>([]);
    const [maxLevel, setMaxLevel] = useState(vipOptionsV2.length - 1);
    const swiperRef = useRef<SwiperRef>(null);
    const [version, setVersion] = useState(0);
    const [currentVipLevel, setCurrentVipLevel] = useState(0);
    const [currentVipDegree, setCurrentVipDegree] = useState(0);

    const refresh = useCallback(() => {
      setVersion(v => v + 1);
    }, []);

    useImperativeHandle(
      ref,
      () => ({
        refresh,
      }),
      [refresh],
    );

    useEffect(() => {
      getVipConfigListV2().then(res => {
        setVipVOList(res);
        const list = res.sort((a, b) => (a.level || 0) - (b.level || 0));
        setMaxLevel(list[list.length - 1]?.level || 0);
        let currentVip = list[list.length - 1];
        let _currentVipStart = 0;
        for (let i = 0; i < list.length; i++) {
          const item = list[i];
          if (
            item.currentExperience != null &&
            item.nextLevelExperience != null &&
            +item.currentExperience < +item.nextLevelExperience
          ) {
            currentVip = item;
            _currentVipStart = i > 0 ? list[i - 1].nextLevelExperience || 0 : 0;
            break;
          }
        }

        onVipLevel?.(currentVip?.level || 0);
        setCurrentVipLevel(currentVip?.level || 0);
        setCurrentVipDegree(
          (currentVip?.currentExperience || 0) - _currentVipStart,
        );
        setTimeout(() => {
          swiperRef.current?.swiper.slideTo(currentVip?.level || 0);
        }, 200);
      });
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [login, version]);

    return vipVOList.length > 0 ? (
      <VipMaxLevelContext.Provider value={maxLevel}>
        <Swiper
          slidesPerView={'auto'}
          spaceBetween={8}
          className={'w-full px-5'}
          ref={swiperRef}
          onSlideChange={(swiper: SwiperType) => {
            const index = swiper.activeIndex;
            onCardChange?.(vipVOList[index]);
          }}>
          {vipVOList.map((item, i) => (
            <SwiperSlide className="w-[21rem] h-[10.5rem]" key={item.level}>
              <VipCard
                login={login}
                vip={item}
                lastVip={i > 0 ? vipVOList[i - 1] : undefined}
                currentVipLevel={currentVipLevel}
                currentVipDegree={currentVipDegree}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </VipMaxLevelContext.Provider>
    ) : null;
  },
);

export default VipCardListV2;
